import React, { useCallback, useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Cookies from 'universal-cookie';

import { SecondaryButton } from '@components/Button/variants';
import IconClose from '@components/Images/Rebranding/IconClose';

import Wrapper from './Wrapper';

interface TopicProps {
  headline: string;
  submitLink: string;
}

const cookies = new Cookies();
const TOPIC_CLOSED_COOKIE = 'sticky-banner-top-closed-topic';

const Topic = ({ headline, submitLink }: TopicProps): JSX.Element => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const canShowBanner = useCallback(() => {
    const isBannerClosed = cookies.get(TOPIC_CLOSED_COOKIE);
    return !isBannerClosed && isVisible;
  }, [isVisible]);

  const closeBanner = () => {
    setIsVisible(false);
    cookies.set(TOPIC_CLOSED_COOKIE, true, { path: '/' });
  };

  return (
    <>
      {canShowBanner() && (
        <Wrapper className="relative bg-primary-magenta">
          <div className="awareness-bar flex flex-row flex-wrap items-center justify-center">
            <div className="mt-8 pb-8 pr-0 text-center font-suisse-neue text-body-md font-normal text-white sm:mt-0 sm:pb-0">
              {ReactHtmlParser(headline)}
            </div>
            <SecondaryButton
              as="link"
              className="bg-white sm:ml-48"
              size="small"
              href={submitLink}
              data-testid="banner-subscribe-link"
            >
              Subscribe
            </SecondaryButton>
            <IconClose
              onClick={closeBanner}
              className="absolute right-0 top-0 m-8 w-12 cursor-pointer stroke-2 text-white md:bottom-0 md:left-[82%] md:m-auto md:w-[26px] md:stroke-1 lg:left-[70%]"
              data-testid="topic-bar-close"
              role="button"
              aria-pressed="false"
            />
          </div>
        </Wrapper>
      )}
    </>
  );
};

export default Topic;
